/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Destination_LocalInputs */

const en_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local Storage`)
};

const fr_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage local`)
};

const de_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokaler Speicher`)
};

const it_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archiviazione locale`)
};

const ru_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Локальное хранилище`)
};

const es_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento local`)
};

const zh_cn2_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本地存储`)
};

const ja_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルストレージ`)
};

const hi_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय भंडारण`)
};

const pt_pt2_options_backup_destination_local = /** @type {(inputs: Options_Backup_Destination_LocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazenamento local`)
};

/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {Options_Backup_Destination_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_destination_local = /** @type {((inputs?: Options_Backup_Destination_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Destination_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_destination_local(inputs)
	if (locale === "de") return de_options_backup_destination_local(inputs)
	if (locale === "it") return it_options_backup_destination_local(inputs)
	if (locale === "ru") return ru_options_backup_destination_local(inputs)
	if (locale === "es") return es_options_backup_destination_local(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_destination_local(inputs)
	if (locale === "ja") return ja_options_backup_destination_local(inputs)
	if (locale === "hi") return hi_options_backup_destination_local(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_destination_local(inputs)
	return en_options_backup_destination_local(inputs)
});